import * as ActionTypes from '../constants/action_types'
import * as utils from './utils'

// -----------------------------------------------------------------------------
// API Calls

function fetchRediscoverNetworkEntities (network, genre, topicIds) {
  const body = { topic_ids: topicIds }
  return utils.makeApiCall({
    url: '/api/discover/network-entities',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_REDISCOVER_ENTITY_IMAGE,
    actionReceive: ActionTypes.RECEIVE_REDISCOVER_ENTITY_IMAGE,
    actionFailure: ActionTypes.REQUEST_REDISCOVER_ENTITY_IMAGE_FAILURE,
    authenticated: true,
    actionProps: {
      network: network,
      genre: genre,
      topicIds: topicIds
    }
  })
}

function fetchRediscoverGenreDemo (genre, genreTopicId, genreTopicIds) {
  const body = { topic_id: genreTopicId, topic_ids: genreTopicIds }
  return utils.makeApiCall({
    url: '/api/discover/genre-demographics',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_REDISCOVER_GENRE_DEMO,
    actionReceive: ActionTypes.RECEIVE_REDISCOVER_GENRE_DEMO,
    actionFailure: ActionTypes.REQUEST_REDISCOVER_GENRE_DEMO_FAILURE,
    authenticated: true,
    actionProps: {
      genre: genre,
      genreTopicId: genreTopicId,
      topicIdsTopicIds: genreTopicIds
    }
  })
}

function fetchDiscoverGenreDemoSummary (genre, genreTopicIds) {
  const body = { topic_ids: genreTopicIds }
  return utils.makeApiCall({
    url: '/api/discover/genre-demographics-summary',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_DISCOVER_GENRE_DEMO_SUMMARY,
    actionReceive: ActionTypes.RECEIVE_DISCOVER_GENRE_DEMO_SUMMARY,
    actionFailure: ActionTypes.REQUEST_DISCOVER_GENRE_DEMO_SUMMARY_FAILURE,
    authenticated: true,
    actionProps: {
      genre: genre,
      topicIdsTopicIds: genreTopicIds
    }
  })
}

function fetchRediscoverNetworkDetails (topicId) {
  return utils.makeApiCall({
    url: `/api/topics/${topicId}/details`,
    actionRequest: ActionTypes.REQUEST_REDISCOVER_NETWORK_DETAILS,
    actionReceive: ActionTypes.RECEIVE_REDISCOVER_NETWORK_DETAILS,
    actionFailure: ActionTypes.REQUEST_REDISCOVER_NETWORK_DETAILS_FAILURE,
    authenticated: true,
    actionProps: {
      topicId: topicId
    }
  })
}

// -----------------------------------------------------------------------------
// User invokable actions

export function fetchRediscoverNetworkEntitiesIfNeeded (network, genre, topicIds) {
  return (dispatch, getState) => {
    const state = (getState().rediscover.byGenre[genre] || {})[network]
    if (utils.shouldFetch(state)) {
      return dispatch(fetchRediscoverNetworkEntities (network, genre, topicIds))
    }
    return Promise.resolve()
  }
}

export function setRediscoverSelectedGenre (genre) {
  return {
    type: ActionTypes.REDISCOVER_SELECTED_GENRE,
    genre
  }
}

export function setRediscoverSelectedGenreNetwork (network) {
  return {
    type: ActionTypes.REDISCOVER_SELECTED_GENRE_NETWORK,
    network
  }
}

export function fetchRediscoverGenreDemoIfNeeded (genre, genreTopicId, genreTopicIds) {
  return (dispatch, getState) => {
    const state = (getState().rediscover.byGenre[genre] || {}).demographics
    if (utils.shouldFetch(state)) {
      return dispatch(fetchRediscoverGenreDemo (genre, genreTopicId, genreTopicIds))
    }
    return Promise.resolve()
  }
}

export function fetchDiscoverGenreDemoSummaryIfNeeded (genre, genreTopicIds) {
  return (dispatch, getState) => {
    const state = (getState().rediscover.byGenre[genre] || {}).demoSummary
    if (utils.shouldFetch(state)) {
      return dispatch(fetchDiscoverGenreDemoSummary (genre, genreTopicIds))
    }
    return Promise.resolve()
  }
}

export function fetchRediscoverNetworkDetailsIfNeeded (topicId) {
  return (dispatch, getState) => {
    const state = (getState().rediscover.byId[topicId] || {}).rediscoverNetwork
    if (utils.shouldFetch(state)) {
      return dispatch(fetchRediscoverNetworkDetails(topicId))
    }
    return Promise.resolve()
  }
}